import { buildDuplicateName } from "@common/helpers/duplicateName";
import { INVOICE_TEMPLATE_NAME_MAX_LENGTH } from "@common/schemas/domains/invoice/invoice-template.schema";

export const buildDuplicateInvoiceTemplateName = (sourceName: string): string =>
    buildDuplicateName({
        sourceName,
        maxLength: INVOICE_TEMPLATE_NAME_MAX_LENGTH,
    });
